document.documentElement.classList.add("js-ready");

const escapeMarkup = (value) =>
  String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");

const getCartToast = () => {
  let toast = document.querySelector("[data-cart-toast]");
  if (toast) return toast;

  toast = document.createElement("div");
  toast.className = "cart-toast";
  toast.dataset.cartToast = "true";
  toast.setAttribute("role", "status");
  toast.setAttribute("aria-live", "polite");
  toast.innerHTML = `
    <p data-cart-toast-message>Added to cart.</p>
    <div class="cart-toast__actions">
      <a href="/cart">View cart</a>
      <button type="button" data-cart-toast-close>Keep shopping</button>
    </div>
  `;
  document.body.append(toast);
  toast.querySelector("[data-cart-toast-close]")?.addEventListener("click", () => {
    toast.classList.remove("is-visible");
  });
  return toast;
};

const updateCartHeader = async () => {
  const cartLink = document.querySelector(".site-header__cart");
  if (!cartLink) return;

  try {
    const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!response.ok) return;
    const cart = await response.json();
    cartLink.textContent = cart.item_count > 0 ? `Cart (${cart.item_count})` : "Cart";
  } catch {
    // Cart count is a nice-to-have; the add still succeeded.
  }
};

document.addEventListener("submit", async (event) => {
  const form = event.target.closest("[data-quick-add-form]");
  if (!form || !window.fetch) return;
  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const originalText = button?.textContent || "Add to cart";
  const productTitle = form.dataset.productTitle || "Coffee";

  if (button) {
    button.disabled = true;
    button.textContent = "Adding...";
  }

  try {
    const response = await fetch(form.action, {
      method: "POST",
      body: new FormData(form),
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.description || "Could not add this coffee yet.");
    }

    const toast = getCartToast();
    const message = toast.querySelector("[data-cart-toast-message]");
    if (message) message.innerHTML = `${escapeMarkup(productTitle)} added to cart.`;
    toast.classList.add("is-visible");
    window.clearTimeout(toast.hideTimer);
    toast.hideTimer = window.setTimeout(() => toast.classList.remove("is-visible"), 7000);
    await updateCartHeader();

    if (button) {
      button.textContent = "Added";
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 1300);
    }
  } catch (error) {
    if (button) {
      button.disabled = false;
      button.textContent = originalText;
    }
    window.location.href = form.action;
  }
});

document.querySelectorAll("[data-product-form]").forEach((form) => {
  const variantInput = form.querySelector("[data-variant-id-input]");
  if (!variantInput) return;

  form.querySelectorAll("[data-variant-choice]").forEach((choice) => {
    choice.addEventListener("change", () => {
      if (choice.checked) variantInput.value = choice.value;
    });
  });
});

const cartForm = document.querySelector("[data-cart-form]");

if (cartForm) {
  cartForm.querySelectorAll("[data-cart-quantity]").forEach((input) => {
    input.addEventListener("input", () => {
      cartForm.classList.add("is-dirty");
      cartForm.querySelectorAll('[name="update"]').forEach((button) => {
        if (button.classList.contains("button")) button.textContent = "Update cart";
      });
    });
  });
}

const heroRoasts = [...document.querySelectorAll("[data-hero-roast]")];

if (heroRoasts.length > 4) {
  const shuffled = heroRoasts
    .map((element) => ({ element, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ element }) => element);

  heroRoasts.forEach((element) => {
    element.dataset.heroVisible = "false";
    element.classList.remove("hero-roast--1", "hero-roast--2", "hero-roast--3", "hero-roast--4");
  });

  shuffled.slice(0, 4).forEach((element, index) => {
    element.dataset.heroVisible = "true";
    element.classList.add(`hero-roast--${index + 1}`);
  });
}

const helper = document.querySelector("[data-coffee-helper]");

if (helper) {
  const dialog = helper.querySelector("[data-coffee-helper-dialog]");
  const openButton = helper.querySelector("[data-coffee-helper-open]");
  const closeButton = helper.querySelector("[data-coffee-helper-close]");
  const nudge = helper.querySelector("[data-helper-nudge]");
  const nudgeOpen = helper.querySelector("[data-helper-nudge-open]");
  const nudgeClose = helper.querySelector("[data-helper-nudge-close]");
  const brewStep = helper.querySelector('[data-helper-step="brew"]');
  const flavorStep = helper.querySelector('[data-helper-step="flavor"]');
  const resultStep = helper.querySelector("[data-helper-result]");
  const flavorWrap = helper.querySelector("[data-helper-flavors]");
  const brewLabel = helper.querySelector("[data-helper-brew-label]");
  const resultTitle = helper.querySelector("[data-helper-result-title]");
  const resultCopy = helper.querySelector("[data-helper-result-copy]");
  const resultLink = helper.querySelector("[data-helper-result-link]");
  const recommendationsWrap = helper.querySelector("[data-helper-recommendations]");
  const helperProducts = (() => {
    try {
      const products = JSON.parse(helper.querySelector("[data-helper-products]")?.textContent || "[]");
      return new Map(products.map((product) => [product.handle, product]));
    } catch {
      return new Map();
    }
  })();

  const productNotes = {
    goldwake: "Medium roast, milk chocolate, roasted peanut.",
    blackline: "Dark roast, bittersweet chocolate, full body.",
    emberfield: "Dark comfort, cocoa, caramel, milk drinks.",
    "steady-signal": "Medium roast, toffee, citrus, cold brew.",
    mapline: "Balanced medium roast for daily drip.",
    plainspoken: "Smooth, clean, easy everyday cup.",
    afterglow: "Dark roast comfort, low acidity.",
    daybreak: "Light roast, citrus, bright finish.",
    brightcut: "Floral, juicy, clean finish.",
    bloomline: "Ethiopia, berry, florals, stone fruit.",
    candelaria: "Light-medium origin with chocolate and maple.",
    cordillera: "Peru, fruit-forward, cold brew friendly.",
    highmark: "Origin clarity with cherry and cane sugar.",
    "quiet-hours": "Decaf with body and dark chocolate.",
  };

  const paths = {
    espresso: {
      label: "Espresso",
      flavors: [
        {
          label: "Chocolate and milk drinks",
          title: "Espresso roasts",
          copy: "Goldwake, Blackline, Emberfield, and Steady Signal are built to hold sweetness and body under pressure.",
          href: "/collections/ots-new-espresso",
          products: ["goldwake", "blackline", "emberfield"],
        },
        {
          label: "Dark and bold",
          title: "Dark espresso",
          copy: "Choose Blackline or Emberfield when you want intensity, crema, and enough structure for milk.",
          href: "/collections/ots-new-dark-bold",
          products: ["blackline", "emberfield", "afterglow"],
        },
      ],
    },
    drip: {
      label: "Drip",
      flavors: [
        {
          label: "Smooth everyday",
          title: "Daily drip",
          copy: "Steady Signal, Mapline, Plainspoken, Goldwake, and Afterglow are easy to keep stocked.",
          href: "/collections/ots-new-daily-drip",
          products: ["steady-signal", "mapline", "plainspoken"],
        },
        {
          label: "Bright and lively",
          title: "Bright drip",
          copy: "Daybreak, Brightcut, Bloomline, Candelaria, Cordillera, and Highmark bring more fruit and lift.",
          href: "/collections/ots-new-bright-fruity",
          products: ["daybreak", "brightcut", "bloomline"],
        },
      ],
    },
    "pour-over": {
      label: "Pour over",
      flavors: [
        {
          label: "Origin clarity",
          title: "Origin discovery",
          copy: "Highmark, Candelaria, Cordillera, and Bloomline reward slower brewing with clearer flavor.",
          href: "/collections/ots-new-origin-discovery",
          products: ["highmark", "candelaria", "cordillera"],
        },
        {
          label: "Fruit and florals",
          title: "Bright and fruity",
          copy: "Choose Daybreak, Brightcut, or Bloomline when you want citrus, berry, florals, and a clean finish.",
          href: "/collections/ots-new-bright-fruity",
          products: ["bloomline", "brightcut", "daybreak"],
        },
      ],
    },
    "cold-brew": {
      label: "Cold brew",
      flavors: [
        {
          label: "Sweet and smooth",
          title: "Cold brew picks",
          copy: "Steady Signal and Cordillera bring the sweetness, body, and clarity that work over ice.",
          href: "/collections/ots-new-cold-brew",
          products: ["steady-signal", "cordillera"],
        },
        {
          label: "Chocolate-forward",
          title: "Cold brew comfort",
          copy: "Start with Steady Signal when you want a smoother cold brew with chocolate and toffee notes.",
          href: "/products/steady-signal",
          products: ["steady-signal", "goldwake"],
        },
      ],
    },
    decaf: {
      label: "Decaf",
      flavors: [
        {
          label: "Evening cup",
          title: "Quiet Hours",
          copy: "A real decaf with body, earthy sweetness, herbs, and dark chocolate for slower evenings.",
          href: "/collections/ots-new-decaf",
          products: ["quiet-hours"],
        },
      ],
    },
  };

  let lastFocusedElement = null;
  let nudgeShown = false;
  let audioPlayed = false;
  const nudgeStorageKey = "otsCoffeeHelperNudgeDismissedAt";
  const currentPath = window.location.pathname;
  const isCoffeeShoppingContext =
    currentPath === "/" ||
    currentPath.includes("/products/") ||
    currentPath.includes("/collections/ots-new") ||
    currentPath.includes("/pages/subscribe");

  const recentlyDismissedNudge = () => {
    const dismissedAt = Number(window.localStorage?.getItem(nudgeStorageKey) || 0);
    return dismissedAt && Date.now() - dismissedAt < 1000 * 60 * 60 * 12;
  };

  const playNudgeSound = () => {
    if (audioPlayed || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    audioPlayed = true;

    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return;
      const context = new AudioContext();
      const gain = context.createGain();
      const firstTone = context.createOscillator();
      const secondTone = context.createOscillator();
      const now = context.currentTime;

      gain.connect(context.destination);
      gain.gain.setValueAtTime(0.0001, now);
      gain.gain.exponentialRampToValueAtTime(0.045, now + 0.025);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.34);

      firstTone.type = "sine";
      firstTone.frequency.setValueAtTime(587.33, now);
      firstTone.connect(gain);
      firstTone.start(now);
      firstTone.stop(now + 0.16);

      secondTone.type = "sine";
      secondTone.frequency.setValueAtTime(783.99, now + 0.11);
      secondTone.connect(gain);
      secondTone.start(now + 0.11);
      secondTone.stop(now + 0.34);

      window.setTimeout(() => context.close?.(), 500);
    } catch {
      // Browser audio policies can block this; the visual nudge still works.
    }
  };

  const hideNudge = (remember = false) => {
    if (!nudge) return;
    nudge.hidden = true;
    helper.classList.remove("coffee-helper--nudging");
    if (remember) {
      window.localStorage?.setItem(nudgeStorageKey, String(Date.now()));
    }
  };

  const showNudge = () => {
    if (!nudge || nudgeShown || !isCoffeeShoppingContext || recentlyDismissedNudge() || !dialog.hidden) return;
    nudgeShown = true;
    nudge.hidden = false;
    helper.classList.add("coffee-helper--nudging");
    playNudgeSound();
    window.setTimeout(() => hideNudge(false), 14000);
  };

  const scheduleNudge = () => {
    if (!isCoffeeShoppingContext || recentlyDismissedNudge()) return;
    const delay = currentPath.includes("/products/")
      ? 6500
      : currentPath.includes("/collections/")
        ? 8500
        : 11500;
    window.setTimeout(showNudge, delay);

    const showAfterBrowsing = () => {
      if (window.scrollY > 360) showNudge();
    };
    window.addEventListener("scroll", showAfterBrowsing, { passive: true, once: true });
  };

  const showStep = (step) => {
    helper.dataset.helperStep = step;
    brewStep.hidden = step !== "brew";
    flavorStep.hidden = step !== "flavor";
    resultStep.hidden = step !== "result";
  };

  const openHelper = () => {
    lastFocusedElement = document.activeElement;
    hideNudge(true);
    dialog.hidden = false;
    document.documentElement.classList.add("coffee-helper-open");
    showStep("brew");
    helper.querySelector('[data-helper-choice="espresso"]')?.focus();
  };

  const closeHelper = () => {
    dialog.hidden = true;
    document.documentElement.classList.remove("coffee-helper-open");
    lastFocusedElement?.focus?.();
  };

  const escapeHtml = (value) =>
    String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const renderRecommendations = (handles = []) => {
    const products = handles.map((handle) => helperProducts.get(handle)).filter(Boolean);
    recommendationsWrap.innerHTML = "";

    products.forEach((product) => {
      const image = product.image
        ? `<a class="coffee-helper-product__image" href="${escapeHtml(product.url)}"><img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy"></a>`
        : `<a class="coffee-helper-product__image coffee-helper-product__image--empty" href="${escapeHtml(product.url)}">OTS</a>`;
      const action = product.available
        ? `<form method="post" action="/cart/add" data-quick-add-form data-product-title="${escapeHtml(product.title)}"><input type="hidden" name="id" value="${escapeHtml(product.variantId)}"><input type="hidden" name="quantity" value="1"><button type="submit">Add ${escapeHtml(product.price)}</button></form>`
        : `<a class="text-link" href="${escapeHtml(product.url)}">View roast</a>`;

      recommendationsWrap.insertAdjacentHTML(
        "beforeend",
        `<article class="coffee-helper-product">
          ${image}
          <div>
            <a class="coffee-helper-product__title" href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a>
            <p>${escapeHtml(productNotes[product.handle] || "Fresh roasted and clean tested.")}</p>
            ${action}
          </div>
        </article>`,
      );
    });
  };

  const renderFlavors = (brew) => {
    const path = paths[brew];
    if (!path) return;

    brewLabel.textContent = path.label;
    flavorWrap.innerHTML = "";

    path.flavors.forEach((flavor) => {
      const button = document.createElement("button");
      button.type = "button";
      button.textContent = flavor.label;
      button.addEventListener("click", () => {
        resultTitle.textContent = flavor.title;
        resultCopy.textContent = flavor.copy;
        resultLink.href = flavor.href;
        resultLink.textContent = flavor.href.includes("/products/") ? "View the roast" : "Shop the full lane";
        renderRecommendations(flavor.products);
        showStep("result");
        recommendationsWrap.querySelector("button, a")?.focus();
      });
      flavorWrap.append(button);
    });

    showStep("flavor");
    flavorWrap.querySelector("button")?.focus();
  };

  openButton?.addEventListener("click", openHelper);
  nudgeOpen?.addEventListener("click", openHelper);
  nudgeClose?.addEventListener("click", () => hideNudge(true));
  closeButton?.addEventListener("click", closeHelper);
  dialog?.addEventListener("click", (event) => {
    if (event.target === dialog) closeHelper();
  });
  helper.querySelectorAll("[data-helper-choice]").forEach((button) => {
    button.addEventListener("click", () => renderFlavors(button.dataset.helperChoice));
  });
  helper.querySelector("[data-helper-back]")?.addEventListener("click", () => showStep("brew"));
  helper.querySelector("[data-helper-restart]")?.addEventListener("click", () => {
    renderRecommendations([]);
    showStep("brew");
    helper.querySelector('[data-helper-choice="espresso"]')?.focus();
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !dialog.hidden) closeHelper();
  });
  scheduleNudge();
}

const subscriptionBuilder = document.querySelector("[data-subscription-builder]");

if (subscriptionBuilder) {
  const cards = [...subscriptionBuilder.querySelectorAll("[data-subscription-product]")];
  const countLabel = subscriptionBuilder.querySelector("[data-subscription-count]");
  const message = subscriptionBuilder.querySelector("[data-subscription-message]");
  const selectedWrap = subscriptionBuilder.querySelector("[data-subscription-selected]");
  const frequencyWrap = subscriptionBuilder.querySelector("[data-subscription-frequency]");
  const frequencyOptions = subscriptionBuilder.querySelector("[data-subscription-frequency-options]");
  const upsell = subscriptionBuilder.querySelector("[data-subscription-upsell]");
  const upsellCopy = subscriptionBuilder.querySelector("[data-subscription-upsell-copy]");
  const error = subscriptionBuilder.querySelector("[data-subscription-error]");
  const submitButton = subscriptionBuilder.querySelector('button[type="submit"]');
  const params = new URLSearchParams(window.location.search);
  const requestedHandle = params.get("product");
  const requestedHandles = [
    requestedHandle,
    ...(params.get("products") || "").split(","),
  ]
    .map((handle) => handle?.trim())
    .filter(Boolean);
  const replaceCart = params.get("replace") === "cart";
  let selectedFrequencyLabel = "";

  const lanePairs = {
    goldwake: "Blackline gives you a darker espresso lane for milk drinks.",
    blackline: "Goldwake is a smoother daily counterpoint to your dark roast.",
    emberfield: "Steady Signal adds a friendly drip or cold brew bag.",
    "steady-signal": "Cordillera gives the same easy cold brew utility with more origin lift.",
    cordillera: "Steady Signal keeps the cold brew lane grounded and chocolatey.",
    bloomline: "Goldwake adds a comforting espresso bag beside the floral cup.",
    highmark: "Blackline adds a bold evening or espresso option.",
    candelaria: "Goldwake keeps the chocolate lane easy for daily brewing.",
    daybreak: "Steady Signal gives you a smoother weekday fallback.",
    brightcut: "Goldwake balances the bright cup with a richer bag.",
    afterglow: "Daybreak gives you a brighter contrast for weekends.",
    mapline: "Bloomline adds origin sparkle to your daily drip.",
    plainspoken: "Goldwake brings a richer roast without getting too dark.",
    "quiet-hours": "Goldwake covers the fully caffeinated daily slot.",
  };

  const escapeHtml = (value) =>
    String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const getSelectedCards = () =>
    cards.filter((card) => card.querySelector("[data-subscription-checkbox]")?.checked);

  const getFrequencyLabel = (card) => {
    const select = card.querySelector("[data-selling-plan-select]");
    return select?.selectedOptions?.[0]?.textContent?.trim() || "Delivery schedule";
  };

  const syncFrequencyOptions = () => {
    if (!frequencyOptions) return;
    const sourceSelect = cards.find((card) => card.querySelector("[data-selling-plan-select]"))?.querySelector("[data-selling-plan-select]");
    if (!sourceSelect) {
      frequencyWrap.hidden = true;
      return;
    }

    const labels = [...sourceSelect.options].map((option) => option.textContent.trim()).filter(Boolean);
    const biweeklyLabel = labels.find((label) => /(?:every\\s*)?2\\s+weeks?/i.test(label));
    selectedFrequencyLabel = selectedFrequencyLabel || biweeklyLabel || labels[0] || "";
    frequencyOptions.innerHTML = labels
      .map(
        (label) =>
          `<button class="subscription-frequency__option" type="button" data-frequency-label="${escapeHtml(label)}" aria-pressed="${label === selectedFrequencyLabel ? "true" : "false"}">${escapeHtml(label.replace(/^Deliver every /i, ""))}</button>`,
      )
      .join("");
  };

  const applyFrequencyToCards = () => {
    if (!selectedFrequencyLabel) return;
    cards.forEach((card) => {
      const select = card.querySelector("[data-selling-plan-select]");
      if (!select) return;
      const matchingOption = [...select.options].find((option) => option.textContent.trim() === selectedFrequencyLabel);
      if (matchingOption) {
        select.value = matchingOption.value;
      }
    });
  };

  const updateFrequencyButtons = () => {
    frequencyOptions?.querySelectorAll("[data-frequency-label]").forEach((button) => {
      button.setAttribute("aria-pressed", String(button.dataset.frequencyLabel === selectedFrequencyLabel));
    });
  };

  const setCardState = (card) => {
    const input = card.querySelector("[data-subscription-checkbox]");
    const label = card.querySelector(".subscription-product__select span");
    card.classList.toggle("is-selected", Boolean(input?.checked));
    if (label) {
      label.textContent = input?.checked ? "Selected" : "Select";
    }
  };

  const updateSummary = () => {
    const selectedCards = getSelectedCards();
    const count = selectedCards.length;
    const firstHandle = selectedCards[0]?.dataset.handle;

    cards.forEach((card) => {
      card.classList.remove("subscription-product--suggested");
    });

    if (count === 0) {
      countLabel.textContent = "Choose your first bag";
      message.textContent = "Pick a roast. Add a second bag if you want a backup or a different brew style.";
      selectedWrap.innerHTML = "";
      upsell.hidden = true;
      return;
    }

    countLabel.textContent = count === 1 ? "1 bag selected" : `${count} bags selected`;
    if (replaceCart) {
      message.textContent =
        count === 1
          ? "We will replace the one-time cart with this subscription bag, then send you back to cart."
          : "We will replace the one-time cart with these subscription bags, then send you back to cart.";
    } else {
      message.textContent =
        count === 1
          ? "Good start. One more bag can cover a second brew method or give you a contrast roast."
          : "That is a real rotation: one checkout, multiple bags, and fewer empty-coffee mornings.";
    }
    selectedWrap.innerHTML = selectedCards
      .map(
        (card) =>
          `<span><strong>${escapeHtml(card.dataset.title || "Selected coffee")}</strong><small>${escapeHtml(getFrequencyLabel(card))}</small></span>`,
      )
      .join("");

    if (count === 1) {
      const suggestedText = lanePairs[firstHandle] || "Add a contrast bag so the subscription covers more than one mood.";
      upsellCopy.textContent = suggestedText;
      upsell.hidden = false;

      const suggestedCard = cards.find((card) => !card.querySelector("[data-subscription-checkbox]")?.checked && !card.classList.contains("subscription-product--disabled"));
      suggestedCard?.classList.add("subscription-product--suggested");
    } else {
      upsell.hidden = true;
    }
  };

  cards.forEach((card) => {
    const checkbox = card.querySelector("[data-subscription-checkbox]");
    const cardFrequency = card.querySelector("[data-selling-plan-select]");
    const cardVariant = card.querySelector("[data-subscription-variant-select]");
    checkbox?.addEventListener("change", () => {
      setCardState(card);
      error.hidden = true;
      updateSummary();
    });
    cardVariant?.addEventListener("change", () => {
      card.dataset.variantId = cardVariant.value;
      error.hidden = true;
    });
    cardFrequency?.addEventListener("change", () => {
      if (checkbox?.checked) {
        selectedFrequencyLabel = cardFrequency.selectedOptions?.[0]?.textContent?.trim() || selectedFrequencyLabel;
        updateFrequencyButtons();
      }
      updateSummary();
    });
    card.addEventListener("click", (event) => {
      const interactive = event.target.closest("a, input, select, button");
      if (interactive || !checkbox || checkbox.disabled) return;
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  requestedHandles.forEach((handle) => {
    const requestedCard = cards.find((card) => card.dataset.handle === handle);
    const checkbox = requestedCard?.querySelector("[data-subscription-checkbox]");
    if (checkbox && !checkbox.disabled) {
      checkbox.checked = true;
      setCardState(requestedCard);
    }
  });

  syncFrequencyOptions();
  frequencyOptions?.addEventListener("click", (event) => {
    const button = event.target.closest("[data-frequency-label]");
    if (!button) return;
    selectedFrequencyLabel = button.dataset.frequencyLabel;
    applyFrequencyToCards();
    updateFrequencyButtons();
    updateSummary();
  });
  applyFrequencyToCards();
  updateFrequencyButtons();
  updateSummary();

  subscriptionBuilder.addEventListener("submit", async (event) => {
    event.preventDefault();
    const selectedCards = getSelectedCards();
    const items = selectedCards
      .map((card) => {
        const sellingPlan = card.querySelector("[data-selling-plan-select]")?.value || card.dataset.sellingPlanId;
        return {
          id: Number(card.dataset.variantId),
          quantity: 1,
          selling_plan: Number(sellingPlan),
        };
      })
      .filter((item) => item.id && item.selling_plan);

    if (!items.length) {
      error.textContent = "Choose at least one subscription-ready roast first.";
      error.hidden = false;
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = "Adding...";
    error.hidden = true;

    try {
      if (replaceCart) {
        const clearResponse = await fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
        });

        if (!clearResponse.ok) {
          throw new Error("Shopify could not convert the cart yet. Try refreshing and starting again.");
        }
      }

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.description || "Shopify could not add this subscription yet.");
      }

      window.location.href = "/cart";
    } catch (addError) {
      error.textContent = addError.message;
      error.hidden = false;
      submitButton.disabled = false;
      submitButton.textContent = "Add subscription to cart";
    }
  });
}
